import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { useLang } from "../../lib/i18n";
import { PageTitle, StatusBadge, Spinner } from "../../components/Shell";
import { toast } from "sonner";
import { Plus, X } from "lucide-react";

export default function Resellers() {
  const [resellers, setResellers] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({ name: "", contact_person: "", email: "", phone: "", type: "Perunding Koperasi", territory: "", commission_setup: 20, commission_recurring: 10 });
  const { lang } = useLang();

  const load = () => api.get("/platform/resellers").then((r) => setResellers(r.data.resellers)).catch(() => {});
  useEffect(() => { load(); }, []);

  const create = async (e) => {
    e.preventDefault();
    try {
      await api.post("/platform/resellers", { ...form, commission_setup: Number(form.commission_setup), commission_recurring: Number(form.commission_recurring) });
      toast.success("Reseller ditambah");
      setShowForm(false);
      load();
    } catch {
      toast.error("Error");
    }
  };

  if (!resellers) return <Spinner />;

  return (
    <div data-testid="platform-resellers">
      <PageTitle title={lang === "bm" ? "Program Reseller" : "Reseller Programme"} sub={`${resellers.length} rakan kongsi aktif`}>
        <button data-testid="add-reseller-btn" onClick={() => setShowForm(true)} className="inline-flex items-center gap-2 bg-brand-deep text-white text-sm font-semibold px-4 py-2.5 rounded-xl hover:bg-brand-dark transition-colors">
          <Plus className="w-4 h-4" /> Reseller
        </button>
      </PageTitle>
      <div className="grid sm:grid-cols-2 xl:grid-cols-3 gap-4">
        {resellers.map((r) => (
          <div key={r.reseller_id} className="bg-card rounded-xl border border-brand-deep/10 p-5 hover:shadow-md transition-shadow" data-testid={`reseller-card-${r.reseller_id.slice(-6)}`}>
            <div className="flex items-start justify-between gap-2">
              <div>
                <div className="font-display font-semibold text-brand-dark">{r.name}</div>
                <div className="text-xs text-muted-foreground mt-0.5">{r.type} • {r.territory || "Malaysia"}</div>
              </div>
              <StatusBadge status={r.status} />
            </div>
            <div className="mt-4 grid grid-cols-3 gap-2 text-center">
              <div className="bg-brand-light rounded-lg py-2">
                <div className="font-mono font-bold text-brand-deep">{r.commission_setup}%</div>
                <div className="text-[10px] uppercase tracking-wide text-muted-foreground">Setup</div>
              </div>
              <div className="bg-brand-light rounded-lg py-2">
                <div className="font-mono font-bold text-brand-deep">{r.commission_recurring}%</div>
                <div className="text-[10px] uppercase tracking-wide text-muted-foreground">Recurring</div>
              </div>
              <div className="bg-gold-light rounded-lg py-2">
                <div className="font-mono font-bold text-gold">{r.customers}</div>
                <div className="text-[10px] uppercase tracking-wide text-muted-foreground">Pelanggan</div>
              </div>
            </div>
            <div className="mt-3 text-xs text-muted-foreground">{r.contact_person} • {r.email}</div>
          </div>
        ))}
      </div>

      {showForm && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
          <div className="absolute inset-0 bg-black/50" onClick={() => setShowForm(false)} />
          <form onSubmit={create} className="relative bg-card rounded-2xl p-6 w-full max-w-md animate-fade-up" data-testid="reseller-form">
            <div className="flex items-center justify-between mb-4">
              <h3 className="font-display font-bold text-brand-dark">Reseller Baharu</h3>
              <button type="button" onClick={() => setShowForm(false)} className="text-muted-foreground"><X className="w-5 h-5" /></button>
            </div>
            <div className="space-y-3">
              <input data-testid="reseller-name-input" required placeholder="Nama Syarikat *" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="w-full rounded-lg border border-input px-3.5 py-2.5 text-sm" />
              <input placeholder="Pegawai" value={form.contact_person} onChange={(e) => setForm({ ...form, contact_person: e.target.value })} className="w-full rounded-lg border border-input px-3.5 py-2.5 text-sm" />
              <input placeholder="Emel" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="w-full rounded-lg border border-input px-3.5 py-2.5 text-sm" />
              <div className="grid grid-cols-2 gap-3">
                <input placeholder="Wilayah" value={form.territory} onChange={(e) => setForm({ ...form, territory: e.target.value })} className="rounded-lg border border-input px-3.5 py-2.5 text-sm" />
                <select value={form.type} onChange={(e) => setForm({ ...form, type: e.target.value })} className="rounded-lg border border-input px-3.5 py-2.5 text-sm bg-white">
                  {["Perunding Koperasi", "Firma Akaun", "Syarikat IT", "Setiausaha Korporat", "Penyedia Latihan", "Ejen Wilayah"].map((t) => <option key={t}>{t}</option>)}
                </select>
              </div>
              <div className="grid grid-cols-2 gap-3">
                <label className="text-xs text-muted-foreground">Komisen Setup %<input type="number" value={form.commission_setup} onChange={(e) => setForm({ ...form, commission_setup: e.target.value })} className="mt-1 w-full rounded-lg border border-input px-3.5 py-2.5 text-sm" /></label>
                <label className="text-xs text-muted-foreground">Komisen Berulang %<input type="number" value={form.commission_recurring} onChange={(e) => setForm({ ...form, commission_recurring: e.target.value })} className="mt-1 w-full rounded-lg border border-input px-3.5 py-2.5 text-sm" /></label>
              </div>
            </div>
            <button data-testid="reseller-submit-btn" type="submit" className="mt-4 w-full bg-brand-deep text-white rounded-xl py-2.5 text-sm font-bold hover:bg-brand-dark transition-colors">Simpan</button>
          </form>
        </div>
      )}
    </div>
  );
}
